
import React from 'react';
import { Link } from 'react-router-dom';

interface NotFoundProps {
    t: any;
}

const NotFound: React.FC<NotFoundProps> = ({ t }) => {
    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 text-center">
            <div className="max-w-2xl">
                <h1 className="text-8xl md:text-[12rem] font-title uppercase tracking-tighter leading-none text-white mb-8 opacity-20">
                    404
                </h1>
                <h2 className="text-3xl md:text-5xl font-title uppercase tracking-tight text-[#00d4ff] mb-6">
                    {t.error_404_title}
                </h2>
                <p className="text-gray-400 text-lg md:text-xl font-light italic leading-relaxed mb-12 max-w-lg mx-auto">
                    {t.error_404_text}
                </p>
                <Link
                    to="/"
                    className="inline-block bg-white text-black px-10 py-4 font-title text-xl uppercase tracking-widest hover:bg-[#00d4ff] transition-colors"
                >
                    {t.error_404_cta}
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
